/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Swal_Confirm_ButtonInputs */



/**
* | output |
* | --- |
* | "Open Browser & Restart" |
*
* @param {Signup_Swal_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_swal_confirm_button = /** @type {((inputs?: Signup_Swal_Confirm_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Swal_Confirm_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le Navigateur et Redémarrer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Browser öffnen und neu starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri il browser e riavvia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте браузер и перезапустите его.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abra el navegador y reinicie")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开浏览器并重启")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ブラウザを開いて再起動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ब्राउज़र खोलें और पुनः आरंभ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra o navegador e reinicie.")
	return /** @type {LocalizedString} */ ("Open Browser & Restart")
});